import { render, staticRenderFns } from "./tableCell.vue?vue&type=template&id=63b5de14&scoped=true"
import script from "./tableCell.vue?vue&type=script&lang=js"
export * from "./tableCell.vue?vue&type=script&lang=js"
import style0 from "./tableCell.vue?vue&type=style&index=0&id=63b5de14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b5de14",
  null
  
)

export default component.exports